<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            PageButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column
          .label Title
          .field-value {{item.title}}
        .column
          .label Slug
          .field-value {{item.slug}}

        .column
          .label Action
          .field-value {{item.action}}
        .column
          .label Created
          .field-value {{item.created_at}}
</template>

<script>
import CardN from '../structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import FederationButtons from '../structure/ui/actions/FederationButtons'
import CouponButtons from '../structure/ui/actions/CouponButtons'
import {mapState} from "vuex";
import PageButtons from "../structure/ui/actions/PageButtons.vue";

export default {
  name: 'Page',
  components: {PageButtons, CouponButtons, FederationButtons, Dropdown, CardN},
  props: ['item', 'type'],
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    defaultLanguage() {
      return this.configuration.application.application_default_language.value
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Page.vue?1bd818a5